import { render, staticRenderFns } from "./ProjectCardCommunication.vue?vue&type=template&id=2c2ca337&scoped=true"
import script from "./ProjectCardCommunication.vue?vue&type=script&lang=js"
export * from "./ProjectCardCommunication.vue?vue&type=script&lang=js"
import style0 from "./ProjectCardCommunication.vue?vue&type=style&index=0&id=2c2ca337&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2ca337",
  null
  
)

export default component.exports